export const dateFormat = (date) => {
        const date_origin = new Date(date.replace(" ", "T"));

        const new_format = new Intl.DateTimeFormat('es-ES', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        }).format(date_origin);

        return new_format;
    }